import type { TRouteObject } from "@ch/helpers/utils/types";
import ErrorPage from "@ch/pages/ErrorPage";
import NotFoundPage from "@ch/pages/NotFoundPage";
import SymptomTrackerPageLazy from "@ch/pages/SymptomTracker";
import AddSymptomsPageLazy from "@ch/pages/SymptomTracker/AddSymptomsLazy";
import { SymptomTrackerPathsEnum } from "./enums";

const SymptomTrackerRoutes: TRouteObject[] = [
  {
    errorElement: <ErrorPage />,
    children: [
      {
        index: true,
        element: <SymptomTrackerPageLazy />,
      },
      {
        path: SymptomTrackerPathsEnum.ADD_SYMPTOM,
        element: <AddSymptomsPageLazy />,
      },
      {
        path: "*",
        element: <NotFoundPage />,
      },
    ],
  },
];

export default SymptomTrackerRoutes;
